import { useRef, memo } from "react";
import { useInlineEditor } from "../Text/Text";
import { toRGBA } from "../parser/utils";
import { ALIGN_MAPPING } from "../constanst";

export const ButtonEditorWrapper = memo(({ data }) => {

  const ref = useRef();

  useInlineEditor(ref, {
    toolbarGroups: [
      { name: "styles", groups: ["styles"] },
      { name: "editing", groups: ["basicstyles"] },
    ],
    onEditorDataChange: (html) => {
      data.html = html;
    }
  });

  return (
    <div
      ref={ref} 
      dangerouslySetInnerHTML={{ __html: data.html }}
    />
  );
});


export default ({ data }) => {
  const { paddingLeft, paddingRight, paddingTop, paddingBottom, backgroundColor, color, borderRadius, align = "center", width, autoWidth } = data;
  return (
    <div style={{ display: "flex", "width": "100%", justifyContent: ALIGN_MAPPING[align] }}>
      <div
        style={{
          backgroundColor: toRGBA(backgroundColor),
          color: toRGBA(color),
          borderRadius, width: autoWidth ? "auto" : `${width}%`,
          paddingLeft,
          paddingRight,
          paddingTop,
          paddingBottom
        }} 
      >
        <ButtonEditorWrapper data={data}/>
      </div>
    </div>
  );
};
